export var SELECTION_COLUMN_ID = '$$OKeeTableSelectionColumn';